module.exports = __webpack_public_path__ + "img/fcdc25accd8435f367a9a6b9f01fb436.png";